var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotDataActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#7043FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2728 26.3336C24.9181 27.673 23.0556 28.5 21 28.5C16.8579 28.5 13.5 25.1421 13.5 21C13.5 19.1787 14.1492 17.5091 15.2287 16.2099L26.2728 26.3336ZM27.2304 25.1765L16.2988 15.1559C17.5849 14.1201 19.2201 13.5 21 13.5C25.1421 13.5 28.5 16.8579 28.5 21C28.5 22.5461 28.0322 23.9828 27.2304 25.1765ZM30 21C30 25.9706 25.9706 30 21 30C16.0294 30 12 25.9706 12 21C12 16.0294 16.0294 12 21 12C25.9706 12 30 16.0294 30 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotDataActive);
export default __webpack_public_path__ + "static/media/notDataActive.f385dd43e060a18243d79ba2c6e1ec12.svg";
export { ForwardRef as ReactComponent };